import { Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material';
import type { Dispatch } from 'react';

import { darkRed, primaryBlue, successGreen } from '../../models/colors';

export const ContactDialogMenu = ({
	open,
	setOpen,
	statusCode,
}: {
	open: boolean;
	setOpen: Dispatch<any>;
	statusCode: number;
}) => {
	const isSuccessful = statusCode === 200;
	return (
		<Dialog open={open}>
			<DialogTitle>
				<Typography
					style={{
						color: isSuccessful ? successGreen : darkRed,
						fontSize: '1.25rem',
						fontFamily: "'Roboto', sans-serif",
					}}
				>
					{isSuccessful
						? 'Your email was sent successfully.'
						: 'Your email failed to send. Please try again.'}
				</Typography>
			</DialogTitle>
			<DialogActions>
				<Button
					variant="text"
					style={{ color: primaryBlue, fontFamily: "'Roboto', sans-serif" }}
					onClick={() => setOpen(false)}
				>
					CLOSE
				</Button>
			</DialogActions>
		</Dialog>
	);
};
